<template lang="html">
  <div class="answer-question" v-if="askInfo">
    <div class="answer-question-header">
      <div class="header-content">
        <div class="header-left">查看问题</div>
        <div class="header-right">
          <el-button size="medium" @click="setInvalid" v-if="loginUserNo === askInfo.correct_staff_no || loginUserNo === askInfo.correct_staff_oldNo || askInfo.login_user_auth">
          <!-- <el-button size="medium" @click="setInvalid"> -->
            <span class="btn-icon"><img src="./img/u31.png"></span>
            <span class="btn-txt">标记为无效问题</span>
          </el-button>
          <el-button size="medium" @click="releaseQuestion" v-if="loginUserNo === askInfo.correct_staff_no || loginUserNo === askInfo.correct_staff_oldNo">
            <span class="btn-icon"><img src="./img/u35.png"></span>
            <span class="btn-txt">释放问题</span>
          </el-button>
          <el-dropdown style="margin-left: 20px">
            <span class="el-dropdown-link">
              <span style="font-weight:700; font-size: 16px; cursor: pointer;">{{ name }}<i class="el-icon-arrow-down el-icon--right"></i></span>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                  <span @click="quitSystem()">
                      退出登录
                  </span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <el-button size="medium" type="primary">保存并发布给学员</el-button> -->
        </div>
      </div>
    </div>
    <div class="placeholder-div"></div>
    <div class="answer-question-main">
      <div class="base-info">
        <p class="base-info-title">基本信息</p>
        <p class="base-info-content">
          <span><i>学员：</i>{{studentName}}</span>
          <span><i>题型：</i>{{questionType}}</span>
          <span><i>答疑老师：</i>{{teacher ? teacher : '-'}}</span>
          <span><i>最新提问时间
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">如果没有追问，则最新提问为第一次提问；<br/>如果有追问，则最新提问为第一个没有回复的追问。</div>
              <i class="el-icon-question"></i>
            </el-tooltip>
            ：</i>{{formatDate(submit_time)}}
          </span>
        </p>
      </div>
      <div class="answer-question-wrapper" v-if="askInfo">
        <div class="tab-title-wrapper">
          <span class="tab-title" :class="[activeTabIndex === i ? 'active' : '']" v-for="(item, i) in askInfo.ask_data" :key="i" @click="changeTab(i)">
            <el-badge v-if="item.teacher_replay_data.replay_status === 0" value="待回复" class="item">
              {{i === 0 ? '问题' : `追问${i}`}}
            </el-badge>
            <span v-if="item.teacher_replay_data.replay_status !== 0">{{i === 0 ? '问题' : `追问${i}`}}</span>
          </span>
          <div class="replyRestTime" v-if="askInfo.ask_data[askInfo.ask_data.length - 1].teacher_replay_data.replay_status === 0">
            <div v-html="replyRestTimeStr"></div>
          </div>
        </div>
        <div v-for="(item, i) in askInfo.ask_data" :key="i">
          <div class="tab-content" :class="[activeTabIndex === i ? 'active' : '']" v-if="activeTabIndex === i">
            <div class="answer-question-left">
              <div v-for="(questionInfo, m) in item.user_ask_data" :key="m">
                <div class="wrapper-title">学员<span class="last-answer-time">{{formatDate(questionInfo.user_ask_time, true)}}</span></div>
                <question-swiper
                  :ifShowBtn="true"
                  :questionsListFromProp="questionInfo.user_ask"
                  :qs_id="questionInfo.qs_id"
                  :canvasId="`canvas${i}-${m}`"
                  :canvasWrapper="`canvas__wrapper${i}-${m}`"
                  :ifCanEidtByCanvas="(item.teacher_replay_data.replay_status === 0 && (loginUserNo === askInfo.correct_staff_no || loginUserNo === askInfo.correct_staff_oldNo || askInfo.login_user_auth)) || ifEidting"
                ></question-swiper>
              </div>
            </div>
            <div class="answer-question-right">
              <div class="wrapper-title teacher-title">
                老师
                <span class="last-answer-time">{{formatDate(item.teacher_replay_data.replay_time, true)}}</span>
              </div>
              <!-- 无老师 -->
              <div class="no-teacher" v-if="!askInfo.correct_staff_no && !askInfo.correct_staff_oldNo && askInfo.replay_status !== 2">暂无老师</div>
              <!-- 可编辑回复 -->
              <comments
                class="ueditor_comments"
                :allCommentsDialog="true"
                :editable="true"
                :textBoxtHeight="300"
                :commentsInfo="item.teacher_replay_data"
                :loginUserNo="loginUserNo"
                :askInfo="askInfo"
                @changeEditing="changeEditing"
              >
              </comments>
              <!-- <div v-if="(loginUserNo === askInfo.correct_staff_no || loginUserNo === askInfo.correct_staff_oldNo)  && askInfo.replay_status !== 2">
                <comments
                  class="ueditor_comments"
                  :allCommentsDialog="true"
                  :editable="true"
                  :textBoxtHeight="300"
                  :commentsInfo="item.teacher_replay_data"
                  :loginUserNo="loginUserNo"
                  :askInfo="askInfo"
                >
                </comments>
              </div> -->
              <!-- 显示回复 不可编辑 -->
              <!-- <div class="dispaly-content" v-if="(loginUserNo !== askInfo.correct_staff_no && loginUserNo !== askInfo.correct_staff_oldNo) && askInfo.replay_status !== 2">
                <div class="dispaly-text-wrapper" v-html="item.teacher_replay_data.content"></div>

              </div> -->
              <!-- 问题标记为无效，显示无效原因 -->
              <div class="invalid-content" v-if="askInfo.replay_status === 2">
                <div>很抱歉！老师无法回答您的问题。</div>
                <div>原因：{{askInfo.invalid_msg}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 标记为无效问题弹框 -->
    <el-dialog title="标记为无效问题" :visible.sync="ifInvalid" custom-class="invalid-modal">
      <div class="setInvalidTip">
        <i class="el-icon-warning"></i>
        当标记为无效问题后，学员将收到“无效问题”的回复，且问题将变为已回复;<br />
        其中无效原因将展示给学员，为了学员更好的体验，请注意礼貌用词。
      </div>
      <el-form :model="form" ref="form" :rules="rules" :label-width="formLabelWidth">
        <el-form-item label="无效类型" prop="invalid_status">
          <el-radio-group v-model="form.invalid_status">
            <el-radio label="1">无用信息</el-radio>
            <el-radio label="2">有害信息</el-radio>
            <el-radio label="3">人身攻击</el-radio>
            <el-radio label="4">污秽色情</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="无效原因" prop="invalid_msg">
          <el-input type="textarea" v-model="form.invalid_msg" placeholder="请输入，不得超过200字"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="ifInvalid = false">取 消</el-button>
        <el-button type="primary" @click="submitInvalid('form')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import $ from 'jquery'
import axios from 'axios'
import moment from 'moment'
import { getURLBase64 } from '@/utils/getURLBase64'
import { SERVER_BASE_URL } from '@/api/api'
import { Loading, Message } from 'element-ui'
import QuestionSwiper from '@/components/question-swiper/question-swiper'
import Comments from '@/components/ueditor/comments-dayi'
// import Questions from '@/components/questions'
// import * as userAnswer from './mock.json'
// type: 作答内容类型, 1: 文字, 2: 批注, 3: 视频, 4: 音频, 5: 文档(包括word、pdf、压缩包等)
export default {
  props: ['userAnswer', 'ques_id'],
  data () {
    return {
      name: '',
      ifInvalid: false,
      form: {
        invalid_status: undefined,
        invalid_msg: undefined
      },
      activeTabIndex: 0,
      formLabelWidth: '90px',
      rules: {
        invalid_status: [
          { required: true, message: '请选择无效类型', trigger: 'change' },
        ],
        invalid_msg: [
          { required: true, message: '请输入无效原因', trigger: 'blur' },
          { max: 200, message: '不得超过200字', trigger: 'blur' }
        ]
      },
      studentName: this.$route.query.studentName,
      questionType: this.$route.query.questionType,
      teacher: this.$route.query.teacher,
      id: this.$route.query.id,
      askInfo: null,
      submit_time: '',
      loginUserNo: '',
      invalidStatusList: [
        '无用信息',
        '有害信息',
        '人身攻击',
        '污秽色情'
      ],
      ifEidting: false,
      logOriginData: null,
      replyRestTimeStr: ''
    }
  },
  components: {
    QuestionSwiper,
    Comments
  },
  created () {
    this.name = window.localStorage.getItem('user_no')
    this.getAskInfo()
  },
  mounted () {
    this.loginUserNo = localStorage.getItem('user_no')
    console.log(this.loginUserNo, this.askInfo)
    document.title = '答疑'
    // this.$bus.$on('getNewInfo', this.getNewInfo)
  },
  methods: {
    changeTab (i) {
      this.activeTabIndex = i
      this.ifEidting = false
    },
    changeEditing (val) {
      this.ifEidting = val
      if (!val) {
        this.askInfo = JSON.parse(JSON.stringify(this.logOriginData))
      }
    },
    // getNewInfo (origin, newPic) {
    //   console.log(origin, newPic)
    //   let askInfo = this.askInfo
    //   askInfo.ask_data.forEach(item => {
    //     item.user_ask_data.forEach((userAsk) => {
    //       console.log(userAsk)
    //       userAsk.user_ask.forEach((one) => {
    //         if (one.answer_pic === origin) {
    //           one.teacher_answer_pic = newPic
    //         }
    //       })
    //     })
    //   })
    //   this.askInfo = JSON.parse(JSON.stringify(askInfo))
    //   console.log(this.askInfo)
    // },
    getAskInfo () {
      if (!this.id) {
        this.$message.error('缺少问答记录id')
        return
      } else {
        this.$api.GETSTUQUESTION({id: this.id}).then(res => {
          if (res.retcode === 0) {
            this.askInfo = res.data
            this.logOriginData = JSON.parse(JSON.stringify(this.askInfo))
            this.submit_time = this.askInfo.submit_time
            this.askInfo.ask_data.forEach((item, i) => {
              if (item.teacher_replay_data.replay_status === 0) {
                // 定位到未回复tab
                this.activeTabIndex = i
              }
            })
            console.log(this.askInfo.ask_data)
            let restTime = new Date().getTime() - this.askInfo.ask_data[this.askInfo.ask_data.length - 1].user_ask_data[0].replay_expire_time * 1000
            if (restTime > 0) { // 已过期
              if ((restTime - 24 * 60 * 60 * 1000) > 0) { // 过期24小时以上
                this.replyRestTimeStr = '<span style="color:red">回复已超时24小时以上</span>'
              } else { // 过期未超过24小时
                let hours = Math.floor(restTime / 1000 / 60 / 60)
                let mins = Math.floor((restTime / 1000 / 60) - (60 * hours))
                this.replyRestTimeStr = `<span style="color:red">回复已超时
                  <i style="background:red; color: #fff; font-style: normal; padding: 1px 3px; border-radius: 2px;">${hours}</i> 小时
                  <i style="background:red; color: #fff; font-style: normal; padding: 1px 3px; border-radius: 2px;">${mins}</i> 分</span>`
              }
            } else { // 未超时
              restTime = Math.abs(restTime)
              let hours = Math.floor(restTime / 1000 / 60 / 60)
              let mins = Math.floor((restTime / 1000 / 60) - (60 * hours))
              this.replyRestTimeStr = `<span>回复时间还剩
                <i style="background:rgb(24, 144, 255); color: #fff; font-style: normal; padding: 1px 3px; border-radius: 2px;">${hours}</i> 小时
                <i style="background:rgb(24, 144, 255); color: #fff; font-style: normal; padding: 1px 3px; border-radius: 2px;">${mins}</i> 分</span>`
            }
            console.log('剩余回复时间 毫秒 ', restTime)
          } else {
            this.$message.error(res.message)
          }
        }).catch((e) => {
          this.$message.error(e)
        })
      }
    },

    formatDate (d, transFlag) {
      if (!d) {
        return ''
      }
      if (transFlag) {
        let now = new Date(this.askInfo.now_time * 1000).getTime()
        let time = new Date(d * 1000).getTime()
        let nowDate = new Date(this.askInfo.now_time * 1000)
        let timeDate = new Date(d * 1000)
        console.log(timeDate.getFullYear())
        let diff = now - time
        // if (diff < (3 * 60 * 1000)) { // 3分钟以内用“刚刚”表示
        //   return '刚刚'
        // } else if (diff >= (3 * 60 * 1000) && diff < (1 * 60 * 60 * 1000)) { // 3分钟<时间<1小时：精确到几分钟前，如“25分钟前”；
        //   return Math.ceil(diff / (1000 * 60)) + '分钟前'
        // } else if (timeDate.getFullYear() < nowDate.getFullYear()) { // 跨年 显示年月日，如“2014.11.11”。
        //   return moment(d * 1000).format('YYYY.MM.DD')
        // } else if (timeDate.getFullYear() === nowDate.getFullYear()) { // 同一年
        //   if (timeDate.getMonth() < nowDate.getMonth()) { // 跨月 显示月份和日期，如“09.07”；
        //     return moment(d * 1000).format('MM.DD')
        //   } else if (timeDate.getMonth() === nowDate.getMonth()) { // 同一月
        //     if (timeDate.getDate() < nowDate.getDate()) { // 跨日
        //       if ((nowDate.getDate() - timeDate.getDate()) === 1) { // 显示昨天几点几分，如“昨天08:50”
        //         return '昨天' + moment(d * 1000).format('HH:mm')
        //       } else { // 显示月份和日期，如“09.07”
        //         return moment(d * 1000).format('MM.DD')
        //       }
        //     } else if (timeDate.getDate() === nowDate.getDate()) { // 同一天 精确到几点几分，如“07:26”
        //       return moment(d * 1000).format('HH:mm')
        //     }
        //   }
        // }
        if (timeDate.getFullYear() < nowDate.getFullYear()) { // 跨年 1年以上：显示年月日和几点几分，如“2019.09.07 08:00”。
          return moment(d * 1000).format('YYYY.MM.DD h:mm')
        } else if (timeDate.getFullYear() === nowDate.getFullYear()) { // 同一年 2天<时间<1年：显示月份、日期和几点几分，如“09.07 08:00”；
          if (timeDate.getMonth() < nowDate.getMonth()) { // 跨月 显示月份和日期，如“09.07 08:00”；
            return moment(d * 1000).format('MM.DD h:mm')
          } else if (timeDate.getMonth() === nowDate.getMonth()) { // 同一月
            if (timeDate.getDate() < nowDate.getDate()) { // 跨日
              if ((nowDate.getDate() - timeDate.getDate()) === 1) { // 显示昨天几点几分，如“昨天08:50”
                return '昨天' + moment(d * 1000).format('HH:mm')
              } else { // 显示月份和日期，如“09.07”
                return moment(d * 1000).format('MM.DD h:mm')
              }
            } else if (timeDate.getDate() === nowDate.getDate()) { // 同一天 精确到几点几分，如“07:26”
              return moment(d * 1000).format('HH:mm')
            }
          }
        }
      }
      return moment(d * 1000).format('YYYY.MM.DD HH:mm:ss')
    },
    handleClick(tab, event) {
      console.log(tab, event);
      this.activeName = tab.name
    },
    setInvalid () {
      if (this.askInfo.replay_status === 1) {
        this.$message.warning('已经回复的问题无法标记为无效')
        return
      }
      this.ifInvalid = true
    },
    submitInvalid (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let is_self = this.loginUserNo === this.askInfo.correct_staff_no || this.loginUserNo === this.askInfo.correct_staff_oldNo ? 1 : 2
          this.$api.MARKINVAILD({id: this.id, ...this.form, is_self}).then(res => {
            if (res.retcode === 0) {
              this.$message({
                message: '无效问题标记成功',
                type: 'success',
                onClose: () => {
                  location.reload()
                }
              })
              // this.$message.success('无效问题标记成功')
              // location.reload()
            } else {
              this.$message.error(res.message)
            }
          }).catch((e) => {
            this.$message.error(e)
          })
        } else {
          return false;
        }
      });
    },
    releaseQuestion () {
      if (this.askInfo.replay_status === 1) {
        this.$message.warning('已经回复的问题无法再释放')
        return
      }
      this.$confirm('确认要释放问题吗？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let is_self = this.loginUserNo === this.askInfo.correct_staff_no || this.loginUserNo === this.askInfo.correct_staff_oldNo ? 1 : 2
        this.$api.ABANDONREPLAY({id: this.id, is_self}).then(res => {
          if (res.retcode === 0) {
            this.$message({
              message: '释放成功',
              type: 'success',
              onClose: () => {
                location.reload()
              }
            })
          } else {
            this.$message.error(res.message)
          }
        }).catch((e) => {
          this.$message.error(e)
        })
      }).catch(() => {
      });
    }
  }
}
</script>

<style lang="less">
.answer-question{
  height: 100%;
  min-width: 880px;
  .answer-question-header{
    height: 60px;
    padding: 0 20px;
    box-sizing: border-box;
    border-bottom: 1px solid #e5e5e5;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: #fff;
    z-index: 99;
    .header-content{
      max-width: 1200px;
      margin: auto;
      overflow: hidden;
      z-index: 5;
      .header-left{
        float: left;
        line-height: 60px;
        font-weight: bold;
      }
      .header-right{
        float: right;
        padding-top: 10px;
        .btn-icon{
          position: absolute;
          img{
            position: relative;
            top: -1px;
          }
        }
        .btn-txt{
          padding-left: 20px;
        }
      }
    }
  }
  .placeholder-div{
    height: 80px;
  }
  .answer-question-main{
    width: 1200px;
    margin: auto;
    .base-info{
      margin-bottom: 20px;
      background: rgb(255, 255, 255);
      // border-radius: 4px;
      padding: 20px 30px;
      p{
        margin: 0;
        padding: 0;
      }
      .base-info-title{
        font-weight: bold;
        position: relative;
        padding-left: 10px;
        &::before{
          content: '';
          position: absolute;
          left: 0;
          width: 4px;
          height: 20px;
          background: #409EFF;
        }
      }
      .base-info-content{
        font-size: 14px;
        padding-top: 8px;
        &>span{
          padding-right: 30px;
        }
        span {
          i{
            color: #7d829a;
            font-style: normal;
          }
        }
      }
    }
    .answer-question-wrapper{
      // display: flex;
      background: rgb(255, 255, 255);
      // border-radius: 4px;
      padding: 10px 30px 20px 30px;
      overflow: hidden;
      .tab-content{
        // opacity: 0;
        // display: none;
        // &.active{
        //   opacity: 1;
        //   display: block;
        // }
      }
      .tab-title-wrapper{
        border-bottom: 1px solid #e5e5e5;
        margin-bottom: 20px;
        overflow: hidden;
        .replyRestTime{
          float: right;
          font-size: 14px;
          padding-top: 5px;
        }
        span.tab-title{
          display: inline-block;
          height: 40px;
          line-height: 40px;
          width: 58px;
          text-align: center;
          margin-right: 20px;
          font-weight: bold;
          font-size: 14px;
          cursor: pointer;
          &.active{
            color: #409EFF;
            position: relative;
            &::after{
              position: absolute;
              content: '';
              width: 100%;
              height: 0;
              border-bottom: 1px solid #409EFF;
              left: 0;
              bottom: 0;
            }
          }
          &:hover{
            color: #409EFF;
          }
        }
      }
      .answer-question-left{
        // flex: 0 60%;
        float: left;
        width: 60%;
        box-sizing: border-box;
        padding-right: 30px;
      }
      .answer-question-right{
        // flex: 0 40%;
        padding-left: 27px;
        float: right;
        width: 40%;
        box-sizing: border-box;
        .replay-btn{
          margin-top: 10px;
          text-align: right;
        }
        .no-teacher{
          color: #999;
          font-size: 14px;
        }
        .dispaly-content{
          font-size: 14px;
          .dispaly-text-wrapper{
            max-height: 350px;
            overflow: auto;
            p{
              margin: 0;
              line-height: 25px;
            }
          }
        }
        .invalid-content{
          font-size: 14px;
        }
      }
      .wrapper-title{
        font-size: 14px;
        line-height: 14px;
        color: #409EFF;
        margin-top: 0;
        margin-bottom: 10px;
        overflow: hidden;
        &.teacher-title{
          color: #67c23a;
        }
        .last-answer-time{
          float: right;
          font-weight: normal;
          color: #999;
        }
      }
    }
  }
  .el-dialog__wrapper .invalid-modal{
    .el-dialog__body{
      padding: 0;
      .setInvalidTip{
        background:#ecf5ff;
        height: auto;
        line-height: 20px;
        padding: 10px 20px 10px 45px;
        position: relative;
        .el-icon-warning{
          position: absolute;
          left: 20px;
          top: 20px;
          color:#409EFF;
          margin-right: 10px;
        }
      }
      .el-form{
        padding: 0 60px 0 20px;
      }
    }
  }
  .el-badge__content.is-fixed{
    top: 7px!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/answer-question/index.vue